export const InputMaxPasswordLength = 24;
